import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">常见问题</h2>
          <p className="text-sm text-foreground-500 mt-2">关于8090影视平台的常见疑问解答</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
              <h3 className="font-heading text-base font-bold text-foreground-900 flex items-start gap-3">
                <span className="text-primary-500 shrink-0 mt-0.5">Q</span>
                <span>{item.question}</span>
              </h3>
              <p className="text-sm text-foreground-600 mt-3 leading-relaxed pl-7">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}